import moment from "moment";
import React, { Fragment, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { UpdateMarkFraud } from "../../../../actions/saleAnalysis";
import { Calculation } from "../../../../utils/Calculation";
import { genrateOrderInvice } from "../../../../actions/order";
import { getTotalCubicUnits } from "../../../../utils/Formula";
import { MMDDYYFormat } from "../../../../utils/dateFormate";
import zipCountyData from "../../../../data/zip_county.json";
import { Col, Row } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";

const OrderDetails = ({ SelectItem, setEdit, IsMount, setIsMount }) => {
  // console.log("SelectItem",SelectItem)
  const dispatch = useDispatch();
  const [MarkAsOk, setMarkAsOk] = useState(false);
  const [SelItem, setSelectItem] = useState(SelectItem);
  const [isStatus, setStatus] = useState(null);
  // console.log(IsMount,"IsMount")

  const updateMarkAsok = async (key) => {
    // setStatus(e.target.checked);
    const res = await dispatch(UpdateMarkFraud(SelectItem?._id, key));
    // console.log("res??????", res);
    if (res) {
      setIsMount(!IsMount);
      // setEdit({
      //   open: false,
      //   edit: "",
      //   title: "",
      // });
    }
  };

  const handleGenrateInvoice = async (id) => {
    try {
      const res = await dispatch(genrateOrderInvice(id));
      // console.log("res",res)
      if (res?.message) {
        setIsMount(!IsMount);
      }
    } catch (error) {}
  };

  const getCountyByZip = (zipCode) => {
    const record = zipCountyData.RECORDS.find(
      (item) => item.zip === Number(zipCode)
    );
    // console.log("record",record)
    return record ? record.county_name : null;
  };

  const updateFraudStatus = (status) => {
    // Handle fraud status update
    setStatus((prev) => ({
      ...prev,
      orderID: {
        ...prev.orderID,
        fraudStatus: status,
      },
    }));
  };

  const getDefaultStatus = () => {
    if (SelectItem?.fraudVerify === true) return "passed";
    if (SelectItem?.fraudVerify === false) return "failed";
    return SelectItem?.fraudVerify;
  };

  const currentStatus = getDefaultStatus() || SelectItem?.orderID?.fraudStatus;

  useEffect(() => {
    // 1. Check if both shipping and billing details exist
    if (
      SelectItem?.orderID?.shippingDetail &&
      SelectItem?.orderID?.billingDetail
    ) {
      // 2. Stringify and compare addresses to check for mismatch
      const shippingAddress = JSON.stringify(SelectItem.orderID.shippingDetail);
      const billingAddress = JSON.stringify(SelectItem.orderID.billingDetail);

      if (shippingAddress !== billingAddress) {
        // 3. Check if the fraud verification field is unpopulated
        if (
          SelectItem?.fraudVerify === undefined ||
          SelectItem?.fraudVerify === null ||
          SelectItem?.fraudVerify === ""
        ) {
          //  console.log(
          //    "Addresses do not match and fraudVerify is empty. Calling fraud method."
          //  );
          updateMarkAsok("required");
        }
      }
    }
  }, [SelectItem]);

  // console.log("currentStatus",currentStatus)

  return (
    <>
      <div className="order-details py-4">
        <div className="px-3 ">
          <h3 className="font-weight-bold">Order Details</h3>

          <div className="product-details-conatiner mt-4">
            <div
              style={{
                flex: 2,
                borderRadius: "5px",
                overflow: "hidden",
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              }}
            >
              <img width={"100%"} src={SelectItem?.mainImage} alt="product" />
            </div>
            <div style={{ flex: 3 }}>
              <h6>{SelectItem?.title}</h6>
              <p>SKU:{SelectItem?.modelNumber}</p>
              <p>Inventory:{SelectItem?.productId?.quantity}</p>
              <p>Qty:{SelectItem?.quantity}</p>
              <p>Unit Price: ${SelectItem?.itemPrice}</p>
            </div>
          </div>
          <div className="order-summary-container my-2">
            <h4 className=" text-left font-weight-bold mb-3">Order Summary</h4>

            <div>
              <div className=" d-flex justify-content-between item-center">
                <span>Card Type:</span>
                <span>{SelectItem?.accountType || ""}</span>
              </div>
              <div className=" d-flex justify-content-between item-center">
                <span>Card last Digits:</span>
                <span>{SelectItem?.accountNumber || ""}</span>
              </div>
              <div className=" d-flex justify-content-between item-center">
                <span>Order Subtotal:</span>
                <span>${Calculation(SelectItem, "OrderSubTotal")}</span>
              </div>
              <div className=" d-flex justify-content-between item-center">
                <span>Cashback Used:</span>
                <span>${SelectItem?.cashbackUsedPerItem}</span>
              </div>
              <div className=" d-flex justify-content-between item-center">
                <span>Discount Applied:</span>
                <span>${SelectItem?.couponDiscount}</span>
              </div>
              <div className=" d-flex justify-content-between item-center">
                <span>Shipping:</span>
                <span>${SelectItem?.shippingFee}</span>
              </div>
              <div className=" d-flex justify-content-between item-center">
                <span>Tax:</span>
                <span>${SelectItem?.itemTax}</span>
              </div>
              <div className=" d-flex justify-content-between item-center">
                <span>Priority Protection:</span>
                <span>${SelectItem?.shippingProtectionFee?.toFixed(2)}</span>
              </div>
              <hr style={{ border: "1px solid black" }} />
              <div className=" d-flex justify-content-between item-center font-weight-bold">
                <span>Total</span>
                <span>${Calculation(SelectItem, "OrderTotal")}</span>
              </div>
              {/* {console.log("selectItem", SelectItem)} */}
              {SelectItem?.cashbackReceivedPerItem ? (
                <button className="cashback-earned mt-4">
                  Cashback Earned: $ {SelectItem?.cashbackReceivedPerItem}
                </button>
              ) : (
                <></>
              )}
              {SelectItem?.eliteCashback ? (
                <button className="elite-earned mt-4">
                  Elite Cashback: $ {SelectItem?.eliteCashback}
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <hr />
        <div className="px-3">
          <div className="order-summary-container">
            <h3 className=" text-left font-weight-bold mb-4">
              Shipping & Billing Information
            </h3>

            <div>
              <h5>Shipping Address:</h5>
              <p>
                {" "}
                {SelectItem?.orderID?.shippingDetail?.address},
                {SelectItem?.orderID?.shippingDetail?.addressTwo
                  ? `${SelectItem?.orderID?.shippingDetail?.addressTwo},`
                  : ""}{" "}
                {SelectItem?.orderID?.shippingDetail?.city}{" "}
                {SelectItem?.orderID?.shippingDetail?.state}{" "}
                {SelectItem?.orderID?.shippingDetail?.postCode}{" "}
                {SelectItem?.orderID?.shippingDetail?.country}{" "}
              </p>
            </div>
            <div className=" my-1">
              <h5 style={{ marginBottom: "0" }}>County Name:</h5>
              <p>
                {getCountyByZip(SelectItem?.orderID?.shippingDetail?.postCode)}
              </p>
            </div>
            <div className=" my-1">
              <h5>Shipping Name:</h5>
              <p>
                {SelectItem?.orderID?.shippingDetail?.firstName}{" "}
                {SelectItem?.orderID?.shippingDetail?.lastName}
              </p>
            </div>
            <div className=" my-1">
              <h5>Shipping Phone:</h5>
              <p>{SelectItem?.orderID?.shippingDetail?.phoneNumber} </p>
            </div>

            {SelectItem?.orderID?.billingDetail ? (
              <div className="mt-4">
                <div>
                  <h5>Billing Address:</h5>
                  <p>
                    {" "}
                    {SelectItem?.orderID?.billingDetail?.address},
                    {SelectItem?.orderID?.billingDetail?.addressTwo
                      ? `${SelectItem?.orderID?.billingDetail?.addressTwo},`
                      : ""}{" "}
                    {SelectItem?.orderID?.billingDetail?.city}{" "}
                    {SelectItem?.orderID?.billingDetail?.state}{" "}
                    {SelectItem?.orderID?.billingDetail?.postCode}{" "}
                    {SelectItem?.orderID?.billingDetail?.country}{" "}
                  </p>
                </div>
                <div className=" my-1">
                  <h5 style={{ marginBottom: "0" }}>County Name:</h5>
                  <p>
                    {getCountyByZip(
                      SelectItem?.orderID?.billingDetail?.postCode
                    )}
                  </p>
                </div>
                <div className=" my-1">
                  <h5>Billing Name:</h5>
                  <p>
                    {SelectItem?.orderID?.billingDetail?.firstName}{" "}
                    {SelectItem?.orderID?.billingDetail?.lastName}
                  </p>
                </div>
                <div className=" my-1">
                  <h5>Billing Phone:</h5>
                  <p>{SelectItem?.orderID?.billingDetail?.phoneNumber} </p>
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className="mt-4">
              <div>
                <h5>Account Email:</h5>
                <p>{SelectItem?.orderID?.user?.email} </p>
              </div>
            </div>
          </div>
        </div>
        <hr style={{ border: "1px solid #cdcdcd" }} />

        {/* {SelectItem?.orderID?.warnings?.length ? ( */}
        <>
          <div className="px-3 my-3">
            <h3 className="text-left font-weight-bold">Fraud check status:</h3>

            <Row className="mt-3">
              {[
                {
                  label: "Fraud check Required",
                  key: "required",
                  color: "#ffb404",
                },
                { label: "Fraud check Sent", key: "sent", color: "#0572bd" },
                {
                  label: "Fraud check Failed",
                  key: "failed",
                  color: "#fb2a3d",
                },
                {
                  label: "Fraud check Passed",
                  key: "passed",
                  color: "#17a858",
                },
              ].map((status, i) => {
                const isActive = currentStatus === status.key;

                return (
                  <Col
                    key={i}
                    md={3}
                    className="mb-2"
                    style={{
                      paddingRight: (i + 1) % 3 === 0 ? 0 : "0px",
                      paddingLeft: "3px",
                    }}
                  >
                    <div
                      className={`d-flex align-items-center px-1 py-2 rounded `}
                      style={{
                        width: "100%",
                        height: "100%",
                        backgroundColor: isActive ? `${status?.color}` : "#fff",
                        color: isActive ? "#fff" : `${status?.color}`,
                        border: isActive
                          ? "1px solid transparent"
                          : "1px solid #000",
                        borderRadius: "8px",
                      }}
                    >
                      <div
                        onClick={() => updateMarkAsok(status.key)}
                        // checked={MarkAsOk}
                        // onChange={(e) => updateMarkAsok(e)}
                        className="d-flex align-items-center justify-content-center me-2"
                        style={{
                          width: "15px",
                          height: "15px",
                          borderRadius: "5px",
                          marginRight: "2px",
                          backgroundColor: isActive ? "#fff" : "#e0e0e0",
                          border: !isActive && "1px solid black",
                          cursor: "pointer",
                          flexShrink: 0,
                        }}
                      >
                        {isActive && (
                          <FaCheck
                            size={11}
                            color="black"
                            style={{ marginTop: "-1px" }}
                          />
                        )}
                      </div>

                      <label
                        htmlFor={status.key}
                        className="m-0"
                        style={{
                          fontSize: "12px",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        onClick={() => updateMarkAsok(status.key)}
                      >
                        {status.label}
                      </label>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
          <hr style={{ border: "1px solid #cdcdcd" }} />
        </>
        {/* ) : (
          <></>
        )} */}
        <div className="px-3">
          <div className="order-summary-container">
            <h3 className=" text-left font-weight-bold mb-2">
              Provided Shipping & Tracking
            </h3>
            <div>
              <h5>Box ID:</h5>
              {SelectItem?.boxId?.split("-")?.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
              <h5 className="mt-3">Total Cube:</h5>

              <p>{getTotalCubicUnits(SelectItem?.dimensions)}</p>

              {/* {console.log(SelectItem?.dimensions)} */}
            </div>

            <div className="my-3">
              <h5>Store Shipping & Tracking</h5>
              <div>
                <h5>Carrier:</h5>
                <p>{SelectItem?.companyName}</p>
              </div>
            </div>
            {SelectItem?.shippingInfo?.labels.length ? (
              <div className="my-3">
                <div>
                  <h4 className=" text-left font-weight-bold mb-2">
                    Recommended Shipping & Tracking
                  </h4>
                  <div>
                    <h5>Carrier:</h5>
                    <p>{SelectItem?.shippingInfo?.labels[0]?.companyName}</p>
                  </div>
                  <div className="mt-1">
                    <h5>Tracking Number: </h5>
                    {SelectItem?.shippingInfo?.labels?.map((item, i) => (
                      <p key={i}>{item?.trackingNumber}</p>
                    ))}
                  </div>
                  <div className="mt-1">
                    <h5>Est. Shipping Date:</h5>
                    <p>{MMDDYYFormat(SelectItem?.shippingInfo?.pickupDate)}</p>
                  </div>
                  <div className="mt-1">
                    <h5>Shipping Type:</h5>
                    <p>
                      {" "}
                      {SelectItem?.shippingInfo?.shippingType
                        ? SelectItem?.shippingInfo?.shippingType
                        : "N/A"}
                    </p>
                  </div>

                  <div className="mt-1">
                    <h5>Insurance Quote Id:</h5>
                    <p>
                      {SelectItem?.shippingInfo?.labels[0]?.insuranceQuoteId
                        ? SelectItem?.shippingInfo?.labels[0]?.insuranceQuoteId
                        : "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <hr className=" m-0" />
        <div className=" pb-3  px-3">
          <button
            className="cashback-earned mt-4"
            onClick={() =>
              !SelectItem?.orderInvoice
                ? handleGenrateInvoice(SelectItem?._id)
                : null
            }
          >
            <a
              href={SelectItem?.orderInvoice}
              target="_blank"
              rel="noopener noreferrer"
            >
              {SelectItem?.orderInvoice
                ? "Download Invoice"
                : "Genrate Invoice"}
            </a>
          </button>
        </div>
      </div>
    </>
  );
};

export default OrderDetails;
